import { axiosClient } from '@nx-frontend/shared/api';
import { WorkspaceMemberDto } from '@nx-frontend/shared/types';

export async function clientGetOrgWorkspaceMembers(orgId: string): Promise<Record<string, WorkspaceMemberDto[]>> {
  if (!orgId) return {};
  try {
    const response = await axiosClient.get<Record<string, WorkspaceMemberDto[]>>(
      `/v2/api/orgs/${orgId}/workspaceMembers/`
    );
    return response.data;
  } catch (err) {
    console.log(`clientGetOrgWorkspaceMembers error: ${err}`);
  }
  return {};
}
